import { InternIcon } from '../intern/icon';
import { LinkActionLink } from '../link/action-link';
import { LinkAssetLink } from '../link/asset-link';
import { LinkExternalLink } from '../link/external-link';
import { LinkInternalLink } from '../link/internal-link';
import { LinkThematischerLink } from '../link/thematischer-link';

/**
 * Model definition for Intro
 */
export interface ContentIntro {
  summary: string;
  __component: 'content.intro';
  id: string;
  text?: string;
  textIcon?: InternIcon;
  link?: [LinkInternalLink | LinkExternalLink | LinkThematischerLink | LinkActionLink | LinkAssetLink];
  linkIcon?: InternIcon;
  component?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div';
}

export function isContentIntro(obj: { __component?: string }): obj is ContentIntro {
  return obj.__component === 'content.intro';
}
